import React from "react";
import { ControlGroupProvider } from "../api/ControlGroup";

interface ControlGroupWrapperProps {
  children: React.ReactNode;
}

const ControlGroupWrapper: React.FC<ControlGroupWrapperProps> = ({
  children,
}) => {
  return <ControlGroupProvider>{children}</ControlGroupProvider>;
};

export default ControlGroupWrapper;
